import store from '../store/index'
import { Message } from 'element-ui';
// 存数据
function setItem (key,value) {
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  window.sessionStorage.setItem(key, value)
}
// 取数据
function getItem (key) {
  const data = window.sessionStorage.getItem(key)
  try {
    return JSON.parse(data)
  } catch (err) {
    return data
  }
}
// 删除数据
function removeItem (key) {
 window.sessionStorage.removeItem(key)
}

// 数组查找ID
function arrFindID (id,arr) {
  let index = arr.findIndex(e=> { return e == id})
  if (index == -1) {
    arr.push(id)
  }else {
    arr.splice(index,1)
  }
  return arr
}


         // 成功提示
function success () {
  Message({
    message: '操作成功',
    type: 'success'
  });
}
        // 失败提示
function error (value) {
  Message.error(value);
 }

 var operateMenuSign =  JSON.parse(window.sessionStorage.getItem('operateMenuSign'));

// var httpUrl = 'https://dms.bendamoto.com/bendaFDMSWeb'//see链接地址域名

var httpUrl = 'https://fdms-test.bendamotor.cn/bendaFDMSTestWeb'//see链接地址域名
// var httpUrl = 'http://hnlzwaq.eicp.net'//see链接地址域名
 
// var httpUrl = 'https://dms-de.bendamoto.com/bendaFDMSWeb'//德国
// 
export default {
  setItem,
  getItem,
  removeItem,
  arrFindID,
  httpUrl,
  operateMenuSign,
  close,
  error,
  success
}

